<template>
  <header
    ref="pageHeader"
    :class="[
      'header header--buyout',
      displayPartnerLogo ? 'header--partner' : '',
      isFixed ? 'is-fixed' : '',
      'extendedBg'
    ]"
  >
    <nuxt-link
      class="header__logo"
      @click="closeBuyoutProcess"
    >
      <client-only>
        <template v-if="displayPartnerLogo">
          <img
            v-if="partnerLogo"
            :src="partnerLogo"
            alt="Partner logo"
            class="icon icon--cashtec"
          >
          <div
            v-if="partnerLogo"
            class="app__title app__title--h4 color--grayTone4"
          >
            +
          </div>
        </template>
      </client-only>
      <img :src="partnerStore.cashtecLogo" class="icon icon--cashtec" alt="CashTec logo">
    </nuxt-link>
    <div class="bNav">
      <div v-if="mainBuyoutStep !==3" class="bNav__item">
        <div :class="['wrapper', mainBuyoutStep === 0 ? 'color--violetTone1': 'color--greenTone1', 'font-weight-medium']">
          <div class="bNav__step bNav__step--main flex-center">
            <div class="color--white">
              1
            </div>
          </div>
          <div class="bNav__desc">
            {{ t("buyout.common.evaluation") }}
          </div>
        </div>
        <div :class="`bNav__step bNav__step--sub ${getAppraisalStepClass(0)}`" />
        <div :class="`bNav__step bNav__step--sub ${getAppraisalStepClass(1)}`" />
        <div :class="`bNav__step bNav__step--sub ${getAppraisalStepClass(2)}`" />
        <div v-if="!buyoutStore.hideMetaMasterStep" :class="`bNav__step bNav__step--sub ${getAppraisalStepClass(3)}`" />
        <div :class="`bNav__step bNav__step--sub ${getAppraisalStepClass(4)}`" />
      </div>
      <div v-if="mainBuyoutStep !==3 && buyoutStore.showBonuses" class="bNav__item">
        <div :class="['wrapper', mainBuyoutStep > 1 ? 'color--greenTone1': '', mainBuyoutStep === 1 ? 'color--violetTone1': '', 'font-weight-medium']">
          <div class="bNav__step bNav__step--main flex-center">
            <div class="color--white">
              2
            </div>
          </div>
          <div class="bNav__desc">
            {{ t("buyout.common.buyout_bonus") }}
          </div>
        </div>
        <div :class="['bNav__step bNav__step--sub', mainBuyoutStep > 1 ? 'color--greenTone1': '', mainBuyoutStep === 1 ? 'color--violetTone1': '']" />
      </div>
      <div v-if="mainBuyoutStep !==3 && (authStore.data?.role != 'partner' || !authStore.isOnlineBuyout)" class="bNav__item">
        <div :class="['wrapper', mainBuyoutStep > 2 ? 'color--greenTone1': '', mainBuyoutStep === 2 ? 'color--violetTone1': '', 'font-weight-medium']">
          <div class="bNav__step bNav__step--main flex-center">
            <div class="color--white">
              {{ buyoutStore.showBonuses ? 3 : 2 }}
            </div>
          </div>
          <div class="bNav__desc">
            {{ t("buyout.common.personal_info") }}
          </div>
        </div>
        <div :class="['bNav__step bNav__step--sub', personalDataStep >= 0 && mainBuyoutStep===2 ? 'color--violetTone1': '']" />
        <div v-if="!(authStore.isLoggedIn && authStore.isPartner && !authStore.isOnlineBuyout)" :class="['bNav__step bNav__step--sub', personalDataStep >= 1 && mainBuyoutStep===2 ? 'color--violetTone1': '']" />
      </div>
      <div v-if="mainBuyoutStep === 3" class="bNav__item">
        <div :class="['wrapper', mainBuyoutStep > 2 ? 'color--greenTone1': '', 'font-weight-medium']">
          <div class="bNav__step bNav__step--main flex-center">
            <div class="color--white">
              <v-icon icon="ct:check" />
            </div>
          </div>
          <div class="bNav__desc">
            {{ t("buyout.thank_you.header.done") }}
          </div>
        </div>
        <div :class="['bNav__step bNav__step--sub', mainBuyoutStep > 2 ? 'color--greenTone1': '']" />
      </div>
    </div>
    <div class="header__actions">
      <common-language-switcher />
      <v-btn
        class="mbtn mbtn--trans"
        size="large"
        append-icon="ct:cross"
        @click="closeBuyoutProcess"
      >
        {{ t("general.close") }}
      </v-btn>
    </div>
  </header>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

const { t } = useI18n();
const buyoutStore = useBuyoutStore();
const authStore = useAuthStore();

const {
  personalDataStep,
  appraisalBuyoutStep,
  mainBuyoutStep
} = storeToRefs(buyoutStore);

const { indexLink } = useHeader();

function getAppraisalStepClass (stepNumber: number) {
  if (mainBuyoutStep.value > 0) {
    return "color--greenTone1";
  }
  if (appraisalBuyoutStep.value >= stepNumber) {
    return "color--violetTone1";
  }

  return "";
}

const isFixed = ref<boolean>(false);
const pageHeader = ref<HTMLElement | null>(null);

onMounted(() => {
  if (pageHeader.value) { isFixed.value = window.scrollY > pageHeader.value.offsetTop; }

  window.document.onscroll = () => {
    if (pageHeader.value) { isFixed.value = window.scrollY > pageHeader.value.offsetTop; }
  };
});

const partnerStore = usePartnerStore();
const displayPartnerLogo = computed<boolean>(() => (partnerStore.getBuyoutPartner !== null));
const partnerLogo = computed<string | undefined>(() => {
  if (partnerStore.getBuyoutPartner !== null) {
    return partnerStore.getBuyoutPartner?.logo;
  }
  return undefined;
});

async function closeBuyoutProcess () {
  await navigateTo(indexLink.value);
  setTimeout(() => {
    buyoutStore.resetBuyoutProcess();
  }, 2000);
}

</script>
